"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZINDEX = exports.TEXT = exports.OPEN = exports.OPACITY = exports.NO_SIZE = exports.MOBILE_RADIUS = exports.MIN_HEIGHT = exports.DEVICE_TYPE = exports.BACKGROUND = void 0;
var DEVICE_TYPE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var ZINDEX = 10;
exports.ZINDEX = ZINDEX;
var OPEN = true;
exports.OPEN = OPEN;
var TEXT = 'Insert any tiles / widgets here';
exports.TEXT = TEXT;
var BACKGROUND = 'black';
exports.BACKGROUND = BACKGROUND;
var MIN_HEIGHT = '200px';
exports.MIN_HEIGHT = MIN_HEIGHT;
var OPACITY = '0.5';
exports.OPACITY = OPACITY;
var NO_SIZE = '0px';
exports.NO_SIZE = NO_SIZE;
var MOBILE_RADIUS = '10px';
exports.MOBILE_RADIUS = MOBILE_RADIUS;